import { yupResolver } from "@hookform/resolvers/yup";
import ipRegex from "ip-regex";

import React, { useCallback } from "react";
import {
  Controller,
  useFieldArray,
  useForm,
  useFormContext,
} from "react-hook-form";
import styled from "styled-components";
import { object, string } from "yup";
import { PrimaryButton } from "../../../../components/button";
import { TextField } from "../../../../components/forms/text";
import { Icon } from "../../../../components/icons";
import { Flex } from "../../../../components/layout";
import { StyledDivider } from "../../../staking/single/form/common";
import { SectionTitle } from "../common/components";
import { InnerFormType } from "./common";

const IpContainer = styled(Flex)`
  &:not(:first-child) {
    margin-top: 1em;
  }
`;

export const WhitelistedIPs: React.FunctionComponent<{}> = () => {
  const { control } = useFormContext<InnerFormType>();

  const whitelistedIPs = useFieldArray<any>({
    control,
    name: "whitelistedIPs",
  });

  const newIPForm = useForm<{ field: string }>({
    resolver: yupResolver(
      object().shape({
        field: string().test({
          message: "Please input a valid IP",
          name: "invalid-up",
          test: (val) => !!(val && ipRegex({ exact: true }).test(val)),
        }),
      })
    ),
  });

  const onNewIp = useCallback(
    (d: { field: string }) => {
      whitelistedIPs.append(d.field);
    },
    [whitelistedIPs.append]
  );

  const newIpValue = newIPForm.watch("field");
  return (
    <>
      <SectionTitle>Whitelisted IPs</SectionTitle>
      <small>
        <em>
          Add any IP addresses that are linked to the list of{" "}
          <strong>prohibited countries</strong> but should still be allowed to
          visit the form
        </em>
      </small>
      {whitelistedIPs.fields.map(({ id }, index) => (
        <Controller
          key={id}
          control={control}
          name={`whitelistedIPs.${index}`}
          render={({ field }) => (
            <IpContainer>
              <strong>{field.value}</strong>
              <div style={{ marginLeft: "1em" }}>
                <Icon
                  type="close"
                  onClick={() => whitelistedIPs.remove(index)}
                />
              </div>
            </IpContainer>
          )}
        />
      ))}
      <IpContainer as="form">
        <div style={{ flexGrow: 1 }}>
          <Controller
            control={newIPForm.control}
            name="field"
            render={({ field, fieldState: { error } }) => (
              <TextField
                fullWidth
                placeholder="e.g. 192.168.1.1"
                {...field}
                error={!!error}
                helperText={error?.message}
              />
            )}
          />
        </div>
        <div style={{ marginLeft: "1em" }}>
          <PrimaryButton
            variant="outlined"
            type="submit"
            onClick={newIPForm.handleSubmit(onNewIp)}
            disabled={newIpValue === "" || newIpValue === undefined}
          >
            Add
          </PrimaryButton>
        </div>
      </IpContainer>
    </>
  );
};
